import React from 'react';
import LoginView from './LoginView';

const LoginContainer = (props) => {
  return <LoginView {...props} />;
};

export default LoginContainer;
